import styles from './TextCardSection.scss?inline';

import {BaseContainer} from "../../base/customComponent/BaseContainer";
import '../../components/TextCard/TextCardCarousel/TextCardCarousel';

class TextCardSection extends BaseContainer {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get variant() {
        return this.dataset.variant ?? 'horizontal';
    }

    get color() {
        return this.dataset.color ?? 'white';
    }

    get tagColor() {
        switch (this.color) {
            case 'light-gray':
                return 'black';
            case 'white':
            default:
                return 'dark-gray';
        }
    }

    get isCarousel() {
        return this.variant === 'carousel';
    }

    get textCardGroupVariantSm() {
        switch (this.variant) {
            case 'vertical':
                return 'stack';
            case 'horizontal':
            default:
                return 'scroll';
        }
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            `text-card-section`,
            `variant-${this.variant}`,
            `color-${this.color}`,
        );
        const group = this.isCarousel
            ? `<nxt-text-card-carousel></nxt-text-card-carousel>`
            : `<nxt-text-card-group variant="${this.textCardGroupVariantSm}" variant-md="columns"></nxt-text-card-group>`;
        container.innerHTML = `
            <header><slot name="header"></slot></header>
            <div class="content">
                <div class="body ${this.isCarousel ? 'carousel' : this.textCardGroupVariantSm}">
                    ${group}
                </div>
            </div>
            <div class="base-grid">
                <div class="cta">
                    <slot name="cta"></slot>
                </div>
            </div>
      `;
        // Set tag colors
        this.querySelectorAll('nxt-tag')
            .forEach(el => el.setAttribute('color', this.tagColor));
        // Clone Slots into container to prevent styling issues
        if (this.getSlotElements('header').length === 0) {
            container.querySelector('header').append(this.createHeader(this.variant));
        }
        const groupSelector = this.isCarousel ? 'nxt-text-card-carousel' : 'nxt-text-card-group';
        this.cloneDefaultSlotContentIntoContainer(container.querySelector(`.body ${groupSelector}`));
        return container;
    }

}

customElements.define('nxt-text-card-section', TextCardSection);
